import router from '../services/router_service';
import indexController from '../controllers/index_controller';

router.on('route:index', indexController);
